export type IntegrationFilterType = 'text' | 'dropdown' | 'date'

export interface IntegrationFilter {
  displayName: string
  required: boolean
  filterKey: string
  dataType: string | undefined
  id: number
  filterType: IntegrationFilterType
  multiValue: boolean
  dynamic: boolean
  options?: IntegrationFilterOption[]
}

export interface IntegrationAssignedFilter {
  id?: number
  integrationFilterId: number
  values: IntegrationFilterValue[]
  operator: FilterOperators
}

export interface IntegrationFilterValue {
  id?: number
  integration_assignment_filters_id?: number
  value: string
  display_name: string
}

export interface IntegrationFilterOption {
  value: string
  display_name: string
  integration_filters_id: number
}

export const DATE_FILTER_FORMAT = 'YYYY-MM-DD'

export type FilterOperators = '<' | '<=' | '=' | '>=' | '>' | 'IN'

export interface DateFilterOption {
  label: string
  value: FilterOperators
}

export interface RequiredDateFilterDefault {
  key: string
  operator: FilterOperators
  value: string
  display_name: string
}
